export const WorkSpaceConstants = {
  GET_WORKSPACE_INITIAL_CONFIG_REQUEST: 'WORKSPACE/GET_WORKSPACE_INITIAL_CONFIG_REQUEST',
  GET_WORKSPACE_INITIAL_CONFIG_SUCCESS: 'WORKSPACE/GET_WORKSPACE_INITIAL_CONFIG_SUCCESS',
  GET_WORKSPACE_INITIAL_CONFIG_FAILED: 'WORKSPACE/GET_WORKSPACE_INITIAL_CONFIG_FAILED',

  GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_REQUEST: 'WORKSPACE/GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_REQUEST',
  GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_SUCCESS: 'WORKSPACE/GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_SUCCESS',
  GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_FAILED: 'WORKSPACE/GET_WORKSPACE_SELECTED_DASHBOARD_CONFIG_FAILED',

  UPDATE_SELECTED_DASHBOARD: 'WORKSPACE/UPDATE_SELECTED_DASHBOARD',
  UPDATE_ACTIVE_DASHBOARD: 'WORKSPACE/UPDATE_ACTIVE_DASHBOARD',
  INITIAL_APPLIED_FILTERS: 'WORKSPACE/INITIAL_APPLIED_FILTERS',
  CLEAR_STORAGE_WORKSPACE: 'WORKSPACE/CLEAR_STORAGE_WORKSPACE',
  ADD_CHART_TO_VISUALISATION_SET: 'ADD_CHART_TO_VISUALISATION_SET',

  SET_CHART_TEMPLATES: 'WORKSPACE/SET_CHART_TEMPLATES'
};
